import { render, staticRenderFns } from "./Cloze.vue?vue&type=template&id=4aec3f0c"
import script from "./Cloze.vue?vue&type=script&lang=js"
export * from "./Cloze.vue?vue&type=script&lang=js"
import style0 from "./Cloze.vue?vue&type=style&index=0&id=4aec3f0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports